import { useTranslation } from 'react-i18next';
import { Spinner, Text, TokenTextAppearance } from '@volkswagen-onehub/components-core';
import styled from 'styled-components';

const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 5rem;
`;

const StyledTextContainer = styled.div`
  margin-bottom: 2rem;
  text-align: center;
`;

export const LoadingSpinner = ({
  showTitle = true,
}: {
  showTitle?: boolean;
}): React.JSX.Element => {
  const { t } = useTranslation();

  return (
    <StyledContainer>
      {showTitle && (
        <StyledTextContainer>
          <Text bold appearance={TokenTextAppearance.headline300} data-testid="loading-title">
            {t(`giveaway.loading.title`)}
          </Text>
        </StyledTextContainer>
      )}
      <Spinner variant="x-large" data-testid="loading-spinner" />
    </StyledContainer>
  );
};
